export const countryThemeList: string[] = ['br', 'mx', 'cl', 'co', 'cr', 'pe'];
